import { Box, CircularProgress, Grid, Typography } from "@mui/material"
import { useState, useEffect } from "react";
import ContactosService from "../../services/contactos.service";
import CardSearchNav from "../card/CardSearchNav";
import SinResultados from "./SinResultados";
import SearchLoading from "./SearchLoading";

const TabContacto = ({textSearch,handleClose}) => {
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const handleSearchContacto = async() => {
        if(textSearch?.length >= 2){
            setIsLoading(true);
            await ContactosService.getAll({search: textSearch, typeSearch: 'soft'}).then((data)=>{
                if(data?.length > 0){
                    setOptions(
                        data?.map((item) =>{
                            if(!item?.id_c){
                                return {
                                    ...item,
                                    tituloCard: item?.nombre_completo,
                                    descripCard: `DNI/CUIT: ${item?.dni_cuit?.numero} - N° CUENTA: ${item?.cuenta} - TEL: ${item?.telefono || '-'}${item?.telefono2 ? ` - TEL2: ${item.telefono2}` : ''}`,
                                    empresaCard: 'NUBICOM',
                                    keyCard: `${item?.cuenta}Cuenta`
                                }
                            }
                            return {
                                ...item,
                                tituloCard: item?.nombreCompleto_c,
                                descripCard: `DNI/CUIT: ${item?.documento_c || 'S/N'} - TEL: ${item?.celular_c || '-'}`,
                                empresaCard: 'NUBICOM',
                                keyCard: `${item?.id_c}Contacto`
                            }
                        })
                    )
                }else{
                    setOptions([])
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
        }
    };

    useEffect(() => {
        const delayWrite = setTimeout(() => {
            handleSearchContacto()
        }, 500)
        return () => clearTimeout(delayWrite)
    }, [textSearch])
    return (
        <Grid container>
            { !isLoading ? (
                <>
                    {options && options?.length > 0 ? (
                        options?.map((option)=>(
                            <Grid item xs={12} key={`${option?.keyCard}c`}>
                                <CardSearchNav
                                    item={option}
                                    descripcion={option?.descripCard}
                                    titulo={option?.tituloCard}
                                    key={option?.keyCard}
                                    onCLoseModal={handleClose}
                                    textSearch={textSearch}
                                />
                            </Grid>
                        ))
                    ):(
                        <Grid item xs={12} key='sinCli'>
                            <SinResultados />
                        </Grid>
                    )}
                </>
            ):(
                <Grid item xs={12} key='circletabcont'>
                    <SearchLoading />
                </Grid>
            )}
        </Grid>
    )
}

export default TabContacto